/**
 * Configuration for RudderStack
 */

/**
 * RudderStack queue options optimized for offline resilience.
 * These are passed to rudder.load() and control how the SDK handles
 * events that fail during delivery (e.g., during buffer flush when network is flaky).
 */
export const RUDDERSTACK_QUEUE_OPTIONS = {
	// 5 seconds
	backoffFactor: 2,
	backoffJitter: 0,
	maxAttempts: 100,
	maxItems: 500,
	maxRetryDelay: 3600000,
	// 1 hour
	minRetryDelay: 5000,
};
